//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopicPill from './TopicPill.vue';
import HorizontalTabsNav from '~/components/ReusableComponents/HorizontalTabsNav.vue';
import analyticEvents from '~/services/analyticEvents';
export default {
    name: 'TopicSelector',
    components: { TopicPill, HorizontalTabsNav },
    inject: ['blogTopic'],
    props: {
        guideTopics: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            selectedTopic: {}
        };
    },
    created() {
        this.selectedTopic =
            this.guideTopics.find((ele) => ele.redirection === this.$route.path) ||
            this.guideTopics[0];
    },
    mounted() {
        if (this.$device.isMobile) {
            const selectedTopicPill = document.getElementById(this.selectedTopic.id);
            selectedTopicPill?.scrollIntoView();
        }
    },
    methods: {
        changeTopic($event) {
            this.selectedTopic = $event;
            this.$store.dispatch('analytics/trackEvent', {
                event: analyticEvents.guide_tab_clicked,
                data: {
                    tab_name: this.selectedTopic.title,
                    guide_name: this.blogTopic.toUpperCase()
                }
            });
            // Perform Redirection Too
        }
    }
};
